import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CurrentStudyVolunteersList from "../../components/DashboardInfo/CurrentStudyVolunteersList";
import { ThemButton } from "../../components/Login/Login.style";
import { MainDiv } from "../../components/Profile/Profile.style";
import { SearchAddDiv } from "../../components/style/Table.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";
import useProfile from "../../hooks/useProfile";

const CurrentStudyVolunteers = () => {
  const navigate = useNavigate();
  const { studyCode } = useParams();
  const [userData, isLoading] = useProfile();
  if (isLoading) {
    return "";
  }
  const user = userData.ugleve_name;

  const moveDashboard = () => {
    navigate("/");
  };
  return (
    <MainDiv>
      <SearchAddDiv>
        <VolunteerHeading>Current Study Volunteers</VolunteerHeading>
        <div>
          <ThemButton onClick={() => moveDashboard()}>
            Back to dashboard
          </ThemButton>
        </div>
      </SearchAddDiv>
      <CurrentStudyVolunteersList user={user} studyCode={studyCode} />
    </MainDiv>
  );
};

export default CurrentStudyVolunteers;
